import Link from './src/link';

Link.install = function(Vue) {
  Vue.component(Link.name, Link);
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/link/index.js